function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M444.6,281.7c7.3-12.4,11.4-25.6,11.4-41.5c0-36.7-31-71.4-71.5-71.4h-30.4c4.1-10.7,7.5-23.5,7.5-38.7 c-0.1-60.8-31.5-87.5-79.5-87.5c-51.3,0-48.4,79.1-59.8,90.6c-18.9,18.9-41.4,55.4-57.4,69.5H82.7c-14.7,0-26.7,11.9-26.7,26.7v200 c0,14.7,11.9,26.7,26.7,26.7H136c12.4,0,22.8-8.5,25.8-20.1c37.1,0.9,62.6,33.3,148.2,33.3c6,0,12.7,0,18.5,0 c64.2,0,93.3-32.9,94.1-79.5c11.1-15.4,17-35.9,14.4-55.9C445.3,318.8,448.4,300.6,444.6,281.7z M393.1,326.5 c10.5,17.6,1.1,41.2-11.6,48c6.4,40.6-14.7,54.9-44.3,54.9h-31.5c-59.6,0-98.3-31.5-143-31.5V242.7h9.1c23.7,0,56.6-59.1,78.7-81.3 c23.7-23.7,15.8-63,31.5-78.7c39.5,0,39.5,27.5,39.5,47.3c0,32.6-23.7,47.3-23.7,78.7h86.7c17.6,0,31.5,15.8,31.5,31.5 c0.1,15.8-10.7,31.5-18.6,31.5C408.7,284.1,411.1,309.5,393.1,326.5L393.1,326.5z"
});

function SvgHelpfulInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpfulInactive);
export default __webpack_public_path__ + "static/media/helpfulInactive.8dad65d7.svg";
export { ForwardRef as ReactComponent };